import React from 'react';
import { ArrowRight, Phone, MessageSquare } from 'lucide-react';
export const Hero = () => {
  return <section className="relative overflow-hidden bg-gradient-to-b from-black via-zinc-950 to-zinc-900 py-20 lg:py-32" data-id="element-164">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(255,255,255,0.03)_0,_transparent_70%)]" data-id="element-165"></div>
      <div className="absolute inset-0 bg-[linear-gradient(to_right,_rgba(255,255,255,0.01)_1px,_transparent_1px),_linear-gradient(to_bottom,_rgba(255,255,255,0.01)_1px,_transparent_1px)] bg-[size:40px_40px]" data-id="element-166"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-167">
        <div className="max-w-4xl mx-auto text-center" data-id="element-168">
          <h2 className="font-['Playfair_Display'] text-zinc-400 mb-4 tracking-wider" data-id="element-169">
            AI AUGMENTATION
          </h2>
          <h1 className="font-['Playfair_Display'] text-4xl md:text-6xl font-light mb-6 leading-tight" data-id="element-170">
            Enhance Your Legal Intake with{' '}
            <span className="text-white" data-id="element-171">AI Assistance</span>
          </h1>
          <p className="font-['Playfair_Display'] text-zinc-300 text-lg md:text-xl mb-10 max-w-2xl mx-auto font-light" data-id="element-172">
            Supercharge your existing intake team with our AI solution that
            seamlessly integrates with your current processes, whether handled
            in-house or through a call center. Respond to leads instantly, 24/7,
            in any language, without changing how your firm operates.
          </p>
          <p className="text-zinc-300 font-['Playfair_Display'] mb-4" data-id="element-173">
            Try Our AI Yourself
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-174">
            <a href="tel:14159808760" className="flex items-center justify-center px-6 py-3 bg-zinc-800/50 hover:bg-zinc-700/50 transition-colors rounded-sm border border-white/10" data-id="element-175">
              <Phone size={18} className="mr-2" data-id="element-176" />
              <span className="font-['Playfair_Display']" data-id="element-177">Call AI</span>
            </a>
            <a href="sms:14159808760" className="flex items-center justify-center px-6 py-3 bg-zinc-800/50 hover:bg-zinc-700/50 transition-colors rounded-sm border border-white/10" data-id="element-178">
              <MessageSquare size={18} className="mr-2" data-id="element-179" />
              <span className="font-['Playfair_Display']" data-id="element-180">Text AI</span>
            </a>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 mt-20" data-id="element-181">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-white/10 pt-10" data-id="element-182">
          <div className="text-center" data-id="element-183">
            <p className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-184">
              24/7
            </p>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm mt-2" data-id="element-185">
              Availability
            </p>
          </div>
          <div className="text-center" data-id="element-186">
            <p className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-187">
              100+
            </p>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm mt-2" data-id="element-188">
              Languages
            </p>
          </div>
          <div className="text-center" data-id="element-189">
            <p className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-190">
              5+
            </p>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm mt-2" data-id="element-191">
              Communication Channels
            </p>
          </div>
          <div className="text-center" data-id="element-192">
            <p className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-193">
              &lt;5
            </p>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm mt-2" data-id="element-194">
              Second Response Time
            </p>
          </div>
        </div>
      </div>
    </section>;
};